import Vue from 'vue'
import Router from 'vue-router'
// 个人信息
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: resolve => require(['@/pages/login'], resolve)
    }, {
      path: '/scan',
      name: 'scan',
      component: resolve => require(['@/pages/scan'], resolve)
    }, {
      path: '/error',
      name: 'loginError',
      component: resolve => require(['@/pages/login'], resolve)
    }, {
      path: '/dashboard',
      name: 'dashboard',
      component: resolve => require(['@/pages/dashboard'], resolve)
    }, {
      path: '/personalCenter/:step',
      name: 'personalCenter',
      meta: {
        menu: '/personalCenter/personalInfo'
      },
      component: resolve => require(['@/pages/personalInformation'], resolve)
    }, {
      path: '/personalInformation',   // ------删除----
      name: 'PersonalInformation',
      meta: {
        menu: '/personalInformation'
      },
      component: resolve => require(['@/pages/personalInformation'], resolve)
    }
  ]
})

// 解决懒加载导致的找不到js的偶现问题
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  const targetPath = router.history.pending.fullPath
  if (isChunkLoadFailed) {
    router.replace(targetPath)
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js